import React from 'react';
import { Select, Alert } from 'antd';
import PropTypes from 'prop-types';
import s from './style.less';

const { Option } = Select;

const renderField = ({ input, label, meta: { touched, error }, options }) => (
  <div className={s.root}>
    <label htmlFor={input.name} {...label && { className: s.flex }}>
      {label && <div>{label}</div>}
      <div>
        <Select
          name={input.name}
          value={input.value}
          onChange={input.onChange}
          style={{ width: '100%' }}
        >
          {options.map(x => (
            <Option key={x.value} disabled={x.disabled} value={x.value}>
              {x.text}
            </Option>
          ))}
        </Select>
        {touched && error && <Alert message={error} type="error" />}
      </div>
    </label>
  </div>
);
renderField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  meta: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
};

export default renderField;
